const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1'])

export const isLocalDevEnvironment = () =>
  import.meta.env.DEV && LOCALHOST_HOSTNAMES.has(window.location.hostname)
